import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Creators from "../pages/creators/page";
import Contact from "../pages/contact/page";
import Apply from "../pages/apply/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/creators",
    element: <Creators />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/apply",
    element: <Apply />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
